<template>
  <work-order-card>
    <h3 slot="card-header">人员信息</h3>
    <div slot="card-body">
    <el-form :label-width="labelWidth" :model="workOrder">
        <el-form-item label="提交人：" v-if="workOrder.sourceChannel =='MBT'">
            {{ workOrder.submitterPeoples && workOrder.submitterPeoples.userName }}
            {{ workOrder.submitterPeoples && workOrder.submitterPeoples.phone }} </br>
        </el-form-item>
         <el-form-item label="提交人：" v-else>
            {{ workOrder.submitterPeoples && workOrder.submitterPeoples.userName }}
            <span style="color: #909399;" v-if="workOrder.submitterPeoples && workOrder.submitterPeoples.deptPath"> 
               （{{workOrder.submitterPeoples.deptPath }}）
            </span>
         </br>
            <!-- 医院：{{ workOrder.submitterPeoples && workOrder.submitterPeoples.hospital }} </br> -->
            <!-- 联系方式：{{ workOrder.submitterPeoples && workOrder.submitterPeoples.phone }} </br> -->
        </el-form-item>
        <el-form-item label="受理人：">
            {{ workOrder.considerPeoples && workOrder.considerPeoples.map(item => item.userName).join(", ") }}
        </el-form-item>
        <el-form-item label="用户信息：" v-if="workOrder&&workOrder.customerList" class="no-wrap">
            <div style="display:flex;flex-direction: column;">
                <el-card v-for="(item, index) in workOrder.customerList" :key="index" class="customer">
                    <div class="customer-item">
                        <div class="customer-item-info mr-15">
                            <span>电话</span>
                            <el-input v-model="item.customerPhone" :readonly="true">
                            </el-input>
                            <el-button type="text" class="copy" :disabled="!item.customerPhone" @click="copyNow" :data-clipboard-text="item.customerPhone" icon="el-icon-document-copy">复制
                            </el-button>
                        </div>
                        <div class="customer-item-info mr-15">
                            <span>ID</span>
                            <el-input v-model="item.customerId" :readonly="true">
                            </el-input>
                            <el-button type="text" class="copy" :disabled="!item.customerId" @click="copyNow" :data-clipboard-text="item.customerId" icon="el-icon-document-copy">复制
                            </el-button>
                        </div>
                        <div class="customer-item-info">
                            <span>备注</span>
                            <el-input v-model="item.remark" :readonly="true">
                            </el-input>
                            <el-button type="text" class="copy" :disabled="!item.remark" @click="copyNow" :data-clipboard-text="item.remark" icon="el-icon-document-copy">复制
                            </el-button>
                        </div>
                    </div>
                </el-card>
            </div>
        </el-form-item>
        <el-form-item label="关注人：" class="no-wrap">
            <div style="display:flex; align-items:center; height:40px; margin-left: 5px;">
                <span>{{ relationUserList || '--'}}</span>
                <el-button type="text" style="margin-left:10px;padding:0;" @click="showDialog" v-if="showEditUser" icon="el-icon-edit">
                    编辑
                </el-button>
            </div>
        </el-form-item>
        <el-dialog title="编辑关注人" :visible.sync="dialog">
            <work-order-user-select v-model="leftUserList" style="width: 100%" :disabledOptions="disabledOptions" disabledOptionsRemark="内置关注人"></work-order-user-select>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" size="small" plain @click="dialog = false">取 消</el-button>
                <el-button type="primary" size="small" @click="updateRelationList">确 定</el-button>
            </span>
        </el-dialog>
    </el-form>
    </div>
  </work-order-card>
</template>

<script>
import api from "plus/api";
import Clipboard from "clipboard";

export default {
    name: "workOrderUserInfo",
    props: {
        workOrder: {
            type: Object,
            default: () => {},
        },
        labelWidth: {
            type: String,
            default: "100px",
        },
    },
    data() {
        return {
            dialog: false,
            leftUserList: [],
            disabledOptions: [],
            isCopy: false,
        };
    },
    methods: {
        showDialog() {
            this.leftUserList =(this.workOrder && this.workOrder.followPeoples) || [];
            if (this.workOrder && this.workOrder.builtIntoFollowPeoples) {
                this.disabledOptions = this.workOrder.builtIntoFollowPeoples.map((item) => item.userId);
            } else {
                this.disabledOptions = [];
            }
            this.dialog = true;
        },
        updateRelationList() {
            let params = {
                relationUserList: this.leftUserList,
                workOrderId: this.workOrder.wkOrderId,
                enableEditAttentionUser:
                    this.userType === "MANAGER"
                        ? true
                        : this.workOrder.enableEditAttentionUser,
            };
            api.work.editRelationUser(params).then((res) => {
                if (res.data.success) {
                    this.$message.success("更新成功");
                    location.reload();
                } else {
                    this.$message.error(res.data.msg);
                }
            });
        },
        copyNow() {
            if (this.isCopy) {
                return;
            }
            this.isCopy = true;
            const clipboard = new Clipboard(".copy");
            clipboard.on("success", (e) => {
                this.$message.success("复制成功");
                this.isCopy = false;
                clipboard.destroy();
            });
            clipboard.on("error", (e) => {
                this.$message.error("该浏览器不支持自动复制");
                this.isCopy = false;
                clipboard.destroy();
            });
        },
    },
    computed: {
        relationUserList() {
            const list = this.workOrder.followPeoples || [];
            return list.map((item) => item.userName).join(",");
        },
        //我关注的工单
        isMyRelationShipOrder() {
            return this.$route.name === "work.relationship.detail";
        },
        // 工单列表详情
        isAllOrder() {
            return this.$route.name === "workmange.workOrderList.detail";
        },
        // 质检详情
        isQualityOrder() {
            return this.$route.name === "workmange.workQuality.detail";
        },
        showEditUser() {
            if (this.isAllOrder || this.isQualityOrder) {
                return true;
            } else if (this.isMyRelationShipOrder) {
                return false;
            } else {
                return this.workOrder.enableEditAttentionUser;
            }
        },
        userType() {
            const userType = new Map([
                ["work.myAccept.detail", "ACCEPTOR"],
                ["work.mySubmit.detail", "AUTHOR"],
                ["workmange.workQuality.detail", "MANAGER"],
                ["workmange.workOrderList.detail", "MANAGER"],
            ]);
            return userType.get(this.$route.name);
        },
    },
};
</script>

<style lang="less" scoped>
.el-form-item {
    margin-bottom: 0px !important;
}
.customer {
    margin-bottom: 20px;
    width: 50%;
    .mr-15 {
        margin-bottom: 15px;
    }

    .customer-item-info {
        display: flex;
        align-items: center;
        span {
            display: inline-block;
            width: 50px;
            padding: 0 10px;
        }

        .copy {
            margin-left: 15px;
        }
    }
}
</style>
